let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("aV0w9")).then(() => parcelRequire('eVkih'));